export default __webpack_public_path__ + "static/media/firmwareUpdate.67cfe642.svg";